export const type = 'alert.phinIdentifier';
